import { useMemo } from 'react';
import {
    RouterProvider,
    createBrowserRouter,
    Navigate,
} from 'react-router-dom';
import ProtectedRoute from './protected.route';
import AppRoot from './app/root.router';
import ErrorPage from './error-boundary';

export const createAppRouter = () =>
    createBrowserRouter([
        {
            path: '/login',
            lazy: async () => {
                const { LoginRoute } = await import('./auth/auth.router');
                return { Component: LoginRoute };
            },
        },
        {
            path: '/',
            element: (
                <ProtectedRoute>
                    <AppRoot />
                </ProtectedRoute>
            ),
            errorElement: <ErrorPage />,
            children: [
                // Default redirect to Task Management
                {
                    index: true,
                    element: <Navigate to="/master/TSK" replace />,
                },
                // Report Route
                {
                    path: 'reports',
                    lazy: async () => {
                        const { ReportRoute } = await import('./app/report/report.router');
                        return { Component: ReportRoute };
                    }
                },
                // Master Route
                {
                    path: ':type/:docType',
                    lazy: async () => {
                        const { MasterRoute } = await import('./app/master/master.router');
                        return { Component: MasterRoute };
                    }
                },
                // Form Route 
                {
                    path: ':type/:docType/:action/:docNo?',
                    lazy: async () => {
                        const { FormRoute } = await import('./app/form/form.router');
                        return { Component: FormRoute };
                    }
                },

            ]
        },
        {
            path: '*',
            element: <Navigate to="/" replace />,
        },
    ]);

const AppRouter = () => {
    const router = useMemo(() => createAppRouter(), []);
    return <RouterProvider router={router} />;
};

export default AppRouter;
